import styled from "styled-components";
import { Card } from "@mui/material";

export const ContentBody = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  flex: 1;
`;
